import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';

import { FuseSharedModule } from '@fuse/shared.module';

import { NoteService } from '../../../shared/services/note.service';
import { NotesComponent } from './notes.component';
import { NoteEditorComponent } from './note-editor/note-editor.component';
import { NotesMainSidenavComponent } from './sidenavs/main/main-sidenav.component';
import { NoteListItemComponent } from './note-list/note-list-item/note-list-item.component';
import { NoteListComponent } from './note-list/note-list.component';
import { NoteDetailsComponent } from './note-details/note-details.component';
import { NoteDialogComponent } from './note-dialog/note-dialog.component';
import { PhoenixDirectivesModule } from '../../../directives/directives.module';
import { StandAloneNoteComponent } from './standalone-note/standalone-notecomponent';
import { NoteDetailItemComponent } from './note-detail-item/note-detail-item.component';
import { NotePageComponent } from './note-page/note-page.component';
import { PhoenixPipesModule } from 'app/pipes/pipes';
import { DragDropModule } from "@angular/cdk/drag-drop";
import { ScrollingModule } from '@angular/cdk/scrolling';
import { SharedModule } from 'app/shared/shared.module';
import { CanDeactivateGuard } from 'app/shared/guards/can-deactivate.guard';
import { HtmlEditorModule } from 'app/components/html-editor/html-editor.module';

const routes: Routes = [
    {
        path     : ':parentType/:parentId/filter/:filterHandle',
        pathMatch : 'full',
        component: NotesComponent,
        resolve  : {
            mail: NoteService,
        },
        canDeactivate: [CanDeactivateGuard],
    },
    {
        path     : ':parentType/:parentId/filter/:filterHandle/:noteId',
        pathMatch : 'full',
        component: NotesComponent,
        resolve  : {
            mail: NoteService,
        },
        canDeactivate: [CanDeactivateGuard],
    },
    {
        path     : ':parentType/:parentId/notetype/:noteTypeHandle',
        pathMatch : 'full',
        component: NotesComponent,
        resolve  : {
            mail: NoteService,
        },
        canDeactivate: [CanDeactivateGuard],
    },
    {
        path     : ':parentType/:parentId/notetype/:noteTypeHandle/:noteId',
        pathMatch : 'full',
        component: NotesComponent,
        resolve  : {
            mail: NoteService,
        },
        canDeactivate: [CanDeactivateGuard],
    },
    // {
    //     path     : ':parentType/:parentId/new',
    //     pathMatch : 'full',
    //     component: StandAloneNoteComponent,
    //     resolve  : {
    //         mail: NoteService,
    //     },
    // },
];

@NgModule({
    declarations: [
        NotesComponent,
        NoteListComponent,
        NoteListItemComponent,
        NoteDetailsComponent,
        NoteEditorComponent,
        NotesMainSidenavComponent,
        NoteDialogComponent,
        StandAloneNoteComponent,
        NoteDetailItemComponent,
        NotePageComponent,
    ],
    imports: [
        RouterModule.forChild(routes),
        MatButtonModule,
        MatCheckboxModule,
        MatDialogModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatMenuModule,
        MatRippleModule,
        MatSelectModule,
        MatSidenavModule,
        MatToolbarModule,
        MatDividerModule,
        MatTooltipModule,
        FuseSharedModule,
        PhoenixDirectivesModule,
        PhoenixPipesModule,
        DragDropModule,
        ScrollingModule,
        SharedModule,
        HtmlEditorModule,
    ],
    providers: [],
    exports: [
        NoteEditorComponent,
        NoteDialogComponent,
        NoteListComponent,
        StandAloneNoteComponent,
        NotePageComponent,
    ]
})
export class NotesModule
{
}
